import React from "react";
import { useSearchParams } from "react-router-dom";
import { AudioLines, Cable, Camera, Images, Layers3, SlidersHorizontal, Video } from "lucide-react";
import { OpsPage, OpsTabs } from "../operations/ui";
import { ScenesSection } from "../operations/sections/ScenesSection";
import { GraphicsSection } from "../operations/sections/GraphicsSection";
import { SourcesSection } from "../operations/sections/SourcesSection";
import { ChasersSection } from "../operations/sections/ChasersSection";
import { SkycamsSection } from "../operations/sections/SkycamsSection";
import { AudioSection } from "../operations/sections/AudioSection";

const tabs = [
  { key: "scenes", label: "Scenes", icon: Layers3 },
  { key: "graphics", label: "Graphics", icon: Images },
  { key: "chasers", label: "Chasers", icon: Camera },
  { key: "skycams", label: "Skycams", icon: Video },
  { key: "sources", label: "Sources", icon: Cable },
  { key: "audio", label: "Audio", icon: AudioLines },
];

const OperationsBuild = () => {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const active = tabs.some((tab) => tab.key === requested) ? requested : "scenes";

  return (
    <OpsPage
      icon={SlidersHorizontal}
      title="Build"
      eyebrow="Scenes · Graphics · Chasers · Skycams · Sources · Audio"
      actions={<OpsTabs tabs={tabs} active={active} onChange={(key) => setParams({ tab: key }, { replace: true })} />}
    >
      {active === "scenes" && <ScenesSection />}
      {active === "graphics" && <GraphicsSection />}
      {active === "chasers" && <ChasersSection />}
      {active === "skycams" && <SkycamsSection />}
      {active === "sources" && <SourcesSection />}
      {active === "audio" && <AudioSection />}
    </OpsPage>
  );
};

export default OperationsBuild;
